<script>
import Header from './header.svelte';
import { onMount } from 'svelte';

onMount(() =>
{
    window.scrollTo(0, 0);
});

</script>

<Header/>

<!-- Main -->
  <div class="container main" style="padding-top: 2.5em;">

    <section>
      <header class="line-after">
          <h3>FACULTY</h3>
      </header>
    </section>

    <!-- Three -->
      <section>
        <div class="row">
          <div class="col-4 col-12-medium">
            <div class="box alt">
              <div class="row gtr-uniform gtr-50">
                <div class="col-12 col-12-xsmall">
                  <div class="image fit">
                    <img src="images/johnedwards.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <center>
              <p>JOHN EDWARDS</p>
              <p>NEUROSURGEON</p>
            </center>
          </div>
          <div class="col-4 col-12-medium">
            <div class="box alt">
              <div class="row gtr-uniform gtr-50">
                <div class="col-12 col-12-xsmall">
                  <div class="image fit">
                    <img src="images/antonbowden.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <center>
              <p>ANTON BOWDEN</p>
              <p>BIOMECHANICS PROFESSOR</p>
            </center>
          </div>
          <div class="col-4 col-12-medium">
            <div class="box alt">
              <div class="row gtr-uniform gtr-50">
                <div class="col-12 col-12-xsmall">
                  <div class="image fit">
                    <img src="images/bryanhoelzer.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <center>
              <p>BRYAN HOELZER</p>
              <p>INTERVENTIONAL PAIN PHYSICIAN</p>
            </center>
          </div>
        </div>
        <div class="row">
        <div class="col-4 col-12-medium">
          <div class="box alt">
            <div class="row gtr-uniform gtr-50">
              <div class="col-12 col-12-xsmall">
                <div class="image fit">
                  <img src="images/gordonmcclean.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
          <center>
            <p>GORDON MCCLEAN</p>
            <p>CHIROPRACTOR</p>
          </center>
        </div>
          <div class="col-4 col-12-medium">
            <div class="box alt">
              <div class="row gtr-uniform gtr-50">
                <div class="col-12 col-12-xsmall">
                  <div class="image fit">
                    <img src="images/ericlee.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <center>
              <p>ERIC LEE</p>
              <p>CHIROPRACTOR</p>
            </center>
          </div>
          <div class="col-4 col-12-medium">
            <div class="box alt">
              <div class="row gtr-uniform gtr-50">
                <div class="col-12 col-12-xsmall">
                  <div class="image fit">
                    <img src="images/garyedwards.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <center>
              <p>GARY EDWARDS</p>
              <p>ORTHOPEDIC SURGEON</p>
            </center>
          </div>
        </div>
        <div class="row">
        <div class="col-4 col-12-medium">
          <div class="box alt">
            <div class="row gtr-uniform gtr-50">

              <div class="col-12 col-12-xsmall">
                <div class="image fit">
                  <img src="images/courtneysherrington.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
          <center>
            <p>COURTNEY CHERRINGTON</p>
            <p>NURSE MANAGER</p>
          </center>
        </div>
        <div class="col-4 col-12-medium">
          <div class="box alt">
            <div class="row gtr-uniform gtr-50">
              <div class="col-12 col-12-xsmall">
                <div class="image fit">
                  <img src="images/robinockey.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
          <center>
            <p>ROBIN OCKEY</p>
            <p>PHYSICIAN/PM&R/PAIN MEDICINE</p>
          </center>
        </div>
        <div class="col-4 col-12-medium">
          <div class="box alt">
            <div class="row gtr-uniform gtr-50">
              <div class="col-12 col-12-xsmall">
                <div class="image fit">
                  <img src="images/lizbaker.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
          <center>
            <p>LIZ BAKER</p>
            <p>CLINICAL PSYCHOLOGIST</p>
          </center>
        </div>
        </div>
        <div class="row">
        <div class="col-4 col-12-medium">
          <div class="box alt">
            <div class="row gtr-uniform gtr-50">
              <div class="col-12 col-12-xsmall">
                <div class="image fit">
                  <img src="images/andreabrock.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
          <center>
            <p>ANDREA BROCK</p>
            <p>NEUROSURGEON</p>
          </center>
        </div>
          <div class="col-4 col-12-medium">
            <div class="box alt">
              <div class="row gtr-uniform gtr-50">
                <div class="col-12 col-12-xsmall">
                  <div class="image fit">
                    <img src="images/richjackson.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <center>
              <p>RICH JACKSON</p>
              <p>NEURORADIOLOGIST</p>
            </center>
          </div>
          <div class="col-4 col-12-medium">
            <div class="box alt">
              <div class="row gtr-uniform gtr-50">
                <div class="col-12 col-12-xsmall">
                  <div class="image fit">
                    <img src="images/carolynanderson-hansen.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <center>
              <p>CAROLYN ANDERSON-HANSEN</p>
              <p>PHYSICIAN ASSISTANT</p>
            </center>
          </div>
        </div>
        <div class="row">
          <div class="col-4 col-12-medium">
            <div class="box alt">
              <div class="row gtr-uniform gtr-50">
                <div class="col-12 col-12-xsmall">
                  <div class="image fit">
                    <img src="images/ryanslater.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <center>
              <p>RYAN SLATER</p>
              <p>ORTHOPEDICS</p>
            </center>
          </div>
          <div class="col-4 col-12-medium">
            <div class="box alt">
              <div class="row gtr-uniform gtr-50">
                <div class="col-12 col-12-xsmall">
                  <div class="image fit">
                    <img src="images/samclark.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <center>
              <p>SAM CLARK</p>
              <p>OWNER, AXIS IN HOME</p>
            </center>
          </div>
          <div class="col-4 col-12-medium">
            <div class="box alt">
              <div class="row gtr-uniform gtr-50">
                <div class="col-12 col-12-xsmall">
                  <div class="image fit">
                    <img src="images/sethkelson.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <center>
              <p>SETH KELSON</p>
              <p>PHYSICAL THERAPIST</p>
            </center>
          </div>
        </div>
        <div class="row">
          <div class="col-4 col-12-medium">
            <div class="box alt">
              <div class="row gtr-uniform gtr-50">
                <div class="col-12 col-12-xsmall">
                  <div class="image fit">
                    <img src="images/snigdhaancha.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <center>
              <p>SNIGDHA ANCHA</p>
              <p>PHYSICIAN</p>
            </center>
          </div>
          <div class="col-4 col-12-medium">
            <div class="box alt">
              <div class="row gtr-uniform gtr-50">
                <div class="col-12 col-12-xsmall">
                  <div class="image fit">
                    <img src="images/tylermurray.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <center>
              <p>TYLER MURRAY</p>
              <p>NURSE PRACTICIONER</p>
            </center>
          </div>
          <div class="col-4 col-12-medium">
            <div class="box alt">
              <div class="row gtr-uniform gtr-50">
                <div class="col-12 col-12-xsmall">
                  <div class="image fit">
                    <img src="images/stevenschiess.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <center>
              <p>STEVEN SCHIESS</p>
              <p>NURSE</p>
            </center>
          </div>
        </div>
      </section>
    </div>



<style>

#main.container {
  padding-top: 3.5em;
  padding-bottom: 3.5em;
}

p {
  color: #fff;
}

center {
  line-height: 0;
}

input[type="submit"] {
  background-color: rgb(0 0 0 / .3);
  box-shadow: none !important;
  color: #fff !important;
  width: 100%;
}


header.major { margin: 1em 0 0 0; }
header.line-after:after {
  content: '';
  display: inline-block;
  width: 10em;
  height: 0.25rem;
  margin: 0em 0 1.5em 0;
  border-radius: 4px;
  background-color: #4a98e2;
}

@media screen and (max-width: 480px) {
  .container > section.line-after:after {
    width: 100%;
    height: 0.25rem;
    margin: 1em 0;
  }
}

@media screen and (max-width: 736px) {
  .image > img {
    max-width: 90%;
    margin: 0 auto;
  }
}

form a
{
    color: rgb(103, 189, 255);
    border-bottom: 0;
}

input.error
{
    border-color: red;
    border-width: 2px;
}

.container.medium.main {
  background-color: #1a242f !important;
  padding-top: 0;
  font-size: 13pt;
}

.container.medium.main input {
    background-color: rgb(0 0 0 / .3);
}

.container.medium.main h4, .container.medium.main h6, input, label, h2, h3 {
  color: #fff !important;
}

label {font-weight: 400;}

.container.medium.main {
  width: 500px;
  max-width: 500px;
}

@media screen and (max-width: 736px) {
  .container.medium.main {
    width: 425px;
  }
}

@media screen and (max-width: 480px) {
  .container.medium.main {
    width: 275px;
  }
}

@media screen and (max-width: 320px) {
  .container.medium.main {
    width: 250px;
  }
}


</style>
